import DesktopInstallSvg from "assets/icons/install-desktop.svg?react";

export default function DesktopInstructions() {
  return (
    <div>
      <h2>برای نصب نسخه دسکتاپ:</h2>
      <p>
        &nbsp; بالا در قسمت نوار جستوجو کنار ادرس سایت بر روی دکمه
        <DesktopInstallSvg width={28} height={28} />
        &nbsp; کلیک کنید
      </p>
    </div>
  );
}
